import usPhoneNumberFormatter from "./format-us-phone";

$(document).on('input', '.phone-number', function() {
  const number = usPhoneNumberFormatter($(this).val());
  $(this).val(number.formatted);
});
